// StockStatusBadge.jsx
// Stock status indicator: OK / Low / At Risk / Short

import React from 'react';

const STATUS_COLORS = {
    ok: { bg: '#dcfce7', text: '#166534' },
    low: { bg: '#fef3c7', text: '#92400e' },
    'at-risk': { bg: '#ffedd5', text: '#9a3412' },
    short: { bg: '#fecaca', text: '#991b1b' }
};

const STATUS_LABELS = {
    ok: 'OK',
    low: 'Low',
    'at-risk': 'At Risk',
    short: 'Short'
};

/**
 * Compute stock status from projected qty and reorder point
 */
export function getStockStatus(projected, reorderPoint) {
    if (projected <= 0) return 'short';
    if (projected < reorderPoint * 0.5) return 'at-risk';
    if (projected < reorderPoint) return 'low';
    return 'ok';
}

const StockStatusBadge = ({ status }) => {
    const colors = STATUS_COLORS[status] || STATUS_COLORS.ok;
    const label = STATUS_LABELS[status] || status;
    return (
        <span style={{
            display: 'inline-block',
            padding: '3px 8px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: 500,
            backgroundColor: colors.bg,
            color: colors.text
        }}>
            {label}
        </span>
    );
};

export default StockStatusBadge;
